import { render, staticRenderFns } from "./hiveDetails.vue?vue&type=template&id=5feddc5f&"
import script from "./hiveDetails.vue?vue&type=script&lang=js&"
export * from "./hiveDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports